module.exports = __webpack_public_path__ + "img/ibmr.ffacc82c.svg";